import type { ApiWalletTransactionCategory, ApiWalletTransactionCounterparty } from '../api/types';

export const METADATA_CATEGORY_COLORS = [
  '#FADADD', '#FFE4C4', '#FFF0B3', '#D8EDC8', '#CCE9E5', '#D5E8FA', '#E1DAF5', '#F1DDF0',
] as const;

export const WALLET_METADATA_DIRECTORY_CHANGED_EVENT = 'wallet-metadata-directory-changed';

export type WalletMetadataDirectoryChange = {
  accountId: string;
  record?: ApiWalletTransactionCounterparty | ApiWalletTransactionCategory;
  removed?: { kind: 'counterparty' | 'category'; id: string };
};

export function notifyWalletMetadataDirectoryChanged(detail?: WalletMetadataDirectoryChange) {
  window.dispatchEvent(new CustomEvent(WALLET_METADATA_DIRECTORY_CHANGED_EVENT, { detail }));
}

export function buildAddressCounterpartyIndex(
  counterparties: ApiWalletTransactionCounterparty[], ownerAddress?: string,
) {
  const matches = new Map<string, ApiWalletTransactionCounterparty[]>();
  counterparties.forEach((counterparty) => counterparty.addresses?.forEach((address) => {
    const key = address.trim();
    const candidates = matches.get(key) ?? [];
    if (!candidates.some(({ id }) => id === counterparty.id)) candidates.push(counterparty);
    matches.set(key, candidates);
  }));
  return new Map([...matches].flatMap(([address, candidates]) => {
    const local = candidates.filter(({ owner_address: owner }) => owner === ownerAddress);
    const eligible = local.length ? local : candidates;
    const selected = eligible.sort((left, right) => right.updated_at.localeCompare(left.updated_at)
      || left.id.localeCompare(right.id))[0];
    return selected ? [[address, selected] as const] : [];
  }));
}

export function resolveAddressCounterparty(
  counterparties: ApiWalletTransactionCounterparty[], address?: string, ownerAddress?: string,
) {
  return address ? buildAddressCounterpartyIndex(counterparties, ownerAddress).get(address.trim()) : undefined;
}
